"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* Classes */
var RequestInterceptor_1 = require("./RequestInterceptor");
Object.defineProperty(exports, "RequestInterceptor", { enumerable: true, get: function () { return RequestInterceptor_1.RequestInterceptor; } });
/* Utils */
var getCleanUrl_1 = require("./utils/getCleanUrl");
Object.defineProperty(exports, "getCleanUrl", { enumerable: true, get: function () { return getCleanUrl_1.getCleanUrl; } });
//# sourceMappingURL=index.js.map